import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as tags from '../../../constants';
import { BasketTimingWrapper, BasketTimingLabel } from './styles';

class BasketTiming extends Component {
  formatDate = (datePassed) => {
    const dateJs = new Date(datePassed);
    const hours = (`0${dateJs.getHours().toLocaleString('it-IT', { timeZone: 'Europe/Rome' })}`).slice(-2);
    const minutes = (`0${dateJs.getMinutes().toLocaleString('it-IT', { timeZone: 'Europe/Rome' })}`).slice(-2);
    return `${hours}:${minutes}`;
  };

  timingCountDown = (date) => {
    const start = new Date(date).getTime();
    const now = Date.now();
    const timeDiff = start - now;
    const seconds = Math.floor(timeDiff / 1000);
    const minute = Math.floor(seconds / 60);
    if ((timeDiff <= 3600000) && (minute > 0)) {
      return `-${minute}'`;
    } else {
      return this.formatDate(date);
    }
  };

  statusLabel = (status, timing, date, competitionId, isTimeKnown) => {
    const statusDictionary = this.props.dictionary.competitionTable.timing;
    if (!isTimeKnown) {
      return 'In attesa di conferma';
    }
    if (status === tags.PLAYING && timing.get('periodId').toString() === tags.PRE_GAME) {
      return statusDictionary.Live;
    } else {
      switch (status) {
        case tags.FIXTURE:
        case tags.PLAYING:
        case tags.PLAYED:
          return this.timingLabel(timing, date, competitionId, isTimeKnown);
        case tags.CANCELLED:
          return statusDictionary.Cancelled;
        case tags.POSTPONED_STATUS:
          return statusDictionary.Postponed;
        case tags.SUSPENDED_STATUS:
          return statusDictionary.Suspended;
        default:
          return this.timingLabel(timing, date, competitionId, isTimeKnown);
      }
    }
  };

  timingLabel = (timing, date, competitionId, isTimeKnown) => {
    const timingDictionary = this.props.dictionary.competitionTable.basketTiming;
    switch (timing.get('periodId').toString()) {
      case tags.PRE_GAME:
        return this.timingCountDown(date);
      case tags.FIRST_HALF_TIME:
      case tags.SECOND_HALF_TIME:
      case tags.FIRST_HALF_BREAK:
      case tags.HALF_TIME_BREAK:
      case tags.SECOND_HALF_BREAK:
      case tags.BEFORE_OVERTIME:
      case tags.POST_GAME:
        return timingDictionary[timing.get('periodId').toString()];
      case tags.FIRST_QUARTER:
      case tags.SECOND_QUARTER:
      case tags.THIRD_QUARTER:
      case tags.FOURTH_QUARTER:
      case tags.OVERTIME:
        switch (competitionId.toString()) {
          case '3':
            return `${timingDictionary[timing.get('periodId').toString()]}/${timing.get('periodTimeMin')}'`;
          default:
            return `${timingDictionary[timing.get('periodId').toString()]}`;
        } default:
        return '';
    }
  };

  isEnded = state => state === tags.PLAYED;

  render() {
    const {
      timing,
      isLive,
      isTimeKnown,
      //isMobile,
      date,
      status,
      competitionId,
    } = this.props;
    return (
      <BasketTimingWrapper>
        <BasketTimingLabel
          color={isLive ? 'liveColor' : 'black'}
          font={(isLive || this.isEnded(status)) ? 'narrowMedium' : 'narrowRegular'}
          size={!isTimeKnown ? '13px' : '15px'}
        >
          {this.statusLabel(status, timing, date, competitionId, isTimeKnown)}
        </BasketTimingLabel>
      </BasketTimingWrapper>
    );
  }
}

BasketTiming.propTypes = {
  timing: PropTypes.shape({
    tag: PropTypes.string,
    val: PropTypes.any,
  }),
  status: PropTypes.any,
  date: PropTypes.any,
  dictionary: PropTypes.any,
  isLive: PropTypes.any,
  competitionId: PropTypes.any,
  isTimeKnown: PropTypes.bool,
  //isMobile: PropTypes.bool,
};

export default BasketTiming;




// WEBPACK FOOTER //
// ./src/components/TimeResults/BasketTiming/index.js